import {define, type, attr, Collection, Record} from 'type-r';
import AccrualModel from "./AccrualModel";
import LandPlotModel from "./LandPlotModel";

const USAGE_DEGREES = {
    resident_all: "живёт постоянно",
    resident_half_year: "живет пол года",
    resident_season: "живет сезон",
    visiter_all: "приезжает регулярно круглый год",
    visiter_season: "приезжает регулярно в сезон",
    visiter_sometimes: "приезжает периодически",
    visiter_rare: "приезжает редко",
    online_user: "не появляется, но активен (онлайн и т.п.)",
    abandoned: "не появляется (и вообще не известно кто это и в общем все плохо)."
}

@define
class Ownership extends Record {
    @attr(String.has.toJSON(false)) address: string;
    @attr account_id: string; // лс
    @attr land_plot_id: number;
    @attr(LandPlotModel) land_plot: LandPlotModel;
    @attr(AccrualModel.Collection) accruals: Collection<AccrualModel>;
    @attr own_type: string;
    @attr own_right: string;
    @attr start_ownership: Date;
    @attr end_ownership: Date;
    @attr usage_degree: string

    get usageDegree() {
        return USAGE_DEGREES[this.usage_degree]
    }
}

export default Ownership;


// WEBPACK FOOTER //
// ./src/models/Ownership.ts